import React, { createContext, useMemo, useState, useContext } from 'react';
import { useTheme, ThemeProvider } from '@material-ui/core/styles';
import { useCustomTheme } from 'hooks/useCustomTheme';
import { FormThemeValues, Theme } from 'assets/types';

interface FormThemeContextType {
  setFormTheme: (theme: FormThemeValues | null) => void;
}

export const FormThemeContext = createContext<FormThemeContextType>({
  setFormTheme: () => {},
});

// Custom hook to use the FormTheme context
export const useFormTheme = () => useContext(FormThemeContext);

interface FormThemeProviderProps {
  children: React.ReactNode;
  theme?: FormThemeValues;
}

const FormThemeProvider = ({
  children,
  theme: formTheme,
}: FormThemeProviderProps) => {
  const baseTheme = useTheme<Theme>();

  // State for live theme updates (for form editor)
  const [
    currentLiveTheme,
    setCurrentLiveTheme,
  ] = useState<FormThemeValues | null>(null);

  const activeTheme = currentLiveTheme || formTheme || {};

  const processedTheme = useCustomTheme(activeTheme, baseTheme);

  const contextValue = useMemo(
    () => ({ setFormTheme: setCurrentLiveTheme }),
    []
  );

  return (
    <FormThemeContext.Provider value={contextValue}>
      <ThemeProvider theme={processedTheme}>{children}</ThemeProvider>
    </FormThemeContext.Provider>
  );
};

export default FormThemeProvider;
